import { render, staticRenderFns } from "./FilterWrapper.vue?vue&type=template&id=ff0d8734&"
import script from "./FilterWrapper.vue?vue&type=script&lang=js&"
export * from "./FilterWrapper.vue?vue&type=script&lang=js&"
import style0 from "./FilterWrapper.vue?vue&type=style&index=0&id=ff0d8734&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports